module.exports = "<span class=\"task-pill\" [popover]=\"popTask\" placement=\"top\" triggers=\"mouseenter:mouseleave\">\n  <strong>{{pillFirst}}</strong> <span class=\"capitalize\">{{pillSecond}}</span>\n  <ng-template #popTask>\n    <div class=\"task-pop-body\" [innerHtml]=\"body\"></div>\n  </ng-template>\n</span>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/automate/task-popover/task-popover.component.html
// module id = ./client/app/automate/task-popover/task-popover.component.html
// module chunks = main